<span class="badge blue"
      *ngIf="booking.medium && !booking?.planning  && booking?.verificationRequested && !booking?.verifiedAt && !booking?.rejectedAt && !booking.deprecated">{{'lang.requirementBookingAssignment.pending' | translate}}</span>
<span class="badge blue"
      *ngIf="booking.medium && booking?.planning && !booking?.verifiedAt && !booking?.rejectedAt && !booking.deprecated">{{'lang.requirementBookingAssignment.pending' | translate}}</span>
<span class="badge green"
      *ngIf="booking.medium && booking?.verifiedAt && !booking.deprecated">{{'lang.requirementBookingAssignment.verified' | translate}}</span>
<span class="badge red"
      *ngIf="booking.medium && booking?.rejectedAt && !booking.deprecated">{{'lang.requirementBookingAssignment.rejected' | translate}}</span>
<span class="badge red"
      *ngIf="booking.medium && booking?.deprecated">{{'lang.requirementBookingAssignment.deprecated' | translate}}</span>
<span class="badge grey"
      *ngIf="!booking.medium && !booking?.excluded">{{'lang.requirementBookingAssignment.missingMotive' | translate}}</span>
<span class="badge grey"
      *ngIf="!booking.medium && booking?.excluded">{{'lang.requirementBookingAssignment.excluded' | translate}}</span>
